module.exports = __webpack_public_path__ + "static/media/icon_footer_twitter.dd9225e2.svg";